class Feature {
    constructor(node) {
        this.isMounted = false;
        this.node = node;
    }
    update() { }
}

export { Feature };
//# sourceMappingURL=Feature.mjs.map
